import React , { useState, useEffect }  from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import {Formik, Form} from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const AddNew = (props) => {
    const [InputName,setInputName] = useState('');
    const [response, fetchData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();

    const validationSchema = Yup.object({
        InputName:Yup.string().required('Required!'),
    });

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", props.Name);
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.InputName);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", props.Name);
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }

    useEffect(() => {
        if(response.Response === true){
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if(response.Response === false){
            alert('Save Failed.')
        }
    },[response])

    useEffect(() => {
        if(responseGetData.length > 0){
            const name = props.Name
            setInputName(responseGetData[0][name])
        }
    },[responseGetData])

    useEffect(() => {
        if(props.PKID !== ''){
            getByIDData();
        }
    },[])

    return(
        <div>
            <Formik initialValues={{InputName:InputName}} 
            validationSchema = {validationSchema} onSubmit = {onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='input' 
                                    type='text' 
                                    label={ props.Name + ' Name'} 
                                    name='InputName' 
                                    onChange={(e) => setInputName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{width:'100%'}}>
                                    <div style={{display:'flex',justifyContent:'center',alignContent:"center"}}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon/>}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => {props.setOpen(false);}}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default AddNew;
